import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { fontStyles } from '../constants/styles';
import { customMarkdown } from '../helpers/markdown';

import ModuleWrapper from './ModuleWrapper';


const Wrapper = styled(ModuleWrapper)`
  ${fontStyles.body};
  text-align: center;
`;


const Instagram = ({ block: { text } }) => (
  <Wrapper>
    {customMarkdown(text)}
  </Wrapper>
);

Instagram.propTypes = {
  block: PropTypes.shape({
    text: PropTypes.string,
  }).isRequired,
};

export default Instagram;
